import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import {
  ClickstreamProvider,
  ClickstreamScene
} from '@zenbusiness/application-commons-clickstream';
import { useEnv } from '@zenbusiness/application-commons-env';

import { NAME } from '#client/build-env';

export default function ClickstreamWrapper({ children, ...delegated }) {
  const { DEPLOY_ENV, RUDDERSTACK_API_KEY, RUDDERSTACK_API_URL } = useEnv();
  const { obo } = useAuthentication();

  const systemProperties = {
    channel: 'web',
    displayTheme: 'light'
  };

  return (
    <ClickstreamProvider
      deployEnv={DEPLOY_ENV}
      noop={!!obo}
      rudderstackApiKey={RUDDERSTACK_API_KEY}
      rudderstackApiUrl={RUDDERSTACK_API_URL}
      {...delegated}
      systemProperties={systemProperties}
    >
      <ClickstreamScene appOrigin={NAME} experienceOrigin="shop">
        {children}
      </ClickstreamScene>
    </ClickstreamProvider>
  );
}
